import { ROUTE_PATH as QUESTIONS_PAGE_PATH } from '@/features/questionsPage/consts';

export const ROUTE_PATH = `${QUESTIONS_PAGE_PATH}/new`;

export const FEATURE_NAME = 'questionCreatePage';
